import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { DeviceListingFieldName, EquipmentListingFieldName } from '../../components/devices.models';

export const METERING_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [DeviceListingFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.INVENTORY_ID,
    value: 5,
    types: [DeviceListingFieldName.MeterNumber],
    hintText: SEARCH_HINTS.InventoryId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.MODEL,
    value: 2,
    types: [DeviceListingFieldName.Description],
    hintText: SEARCH_HINTS.Model
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERIAL_NUMBER,
    value: 3,
    types: [DeviceListingFieldName.SerialNumber],
    hintText: SEARCH_HINTS.SerialNumber
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERVICE_LOCATION_NUMBER,
    value: 4,
    types: [DeviceListingFieldName.ServiceLocationIds],
    hintText: SEARCH_HINTS.ServiceLocationNumber
  }
];

export const METERING_DEFAULT_SEARCH_TYPE: SearchType = METERING_SEARCH_TYPES[0];

export const METERING_SORT_FIELD: Record<string, EquipmentListingFieldName> = {
  deviceTypeName: DeviceListingFieldName.DeviceType,
  model: DeviceListingFieldName.Description,
  status: DeviceListingFieldName.Status,
  deviceStatusValue: DeviceListingFieldName.Health,
  lastHeard: DeviceListingFieldName.LastHeard,
  batteryStatus: DeviceListingFieldName.BatteryStatus,
  transmissionReadRateStatus: DeviceListingFieldName.TransmissionReadRateStatus,
  validTransmissionReadRateStatus: DeviceListingFieldName.ValidTransmissionReadRateStatus,
  commodity: DeviceListingFieldName.Commodity,
  meterNumber: DeviceListingFieldName.MeterNumber
};
